import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { SELL_STEPS } from "../mock";
import LeadForm from "./LeadForm";

export default function SellCar() {
  const [open, setOpen] = useState(false);
  return (
    <section id="vendi" className="cm-reveal py-8 lg:py-12">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="overflow-hidden rounded-[24px] bg-[var(--cm-dark)] px-8 py-14 lg:px-16 lg:py-20">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-20">
            <div>
              <p className="mb-6 font-mono-cm text-[0.68rem] uppercase tracking-[0.18em] text-[var(--cm-green)]">
                02 — Vendi con Carmaps
              </p>
              <h2 className="h-display text-[clamp(2rem,4vw,3.2rem)] text-white">
                Vuoi vendere la tua auto?{" "}
                <span className="font-serif-cm text-white/70">Scopri il modello: Carmaps</span>
              </h2>
              <p className="mt-7 max-w-[440px] text-[1rem] leading-relaxed text-white/60">
                Carmaps si occupa di valutazione, presentazione professionale,
                pubblicità, gestione degli acquirenti, documentazione e processo
                di vendita. Tu mantieni il controllo della tua auto fino alla
                fine.
              </p>
              <button
                onClick={() => setOpen(true)}
                className="mt-9 inline-flex items-center gap-2 rounded-full px-6 py-3.5 text-[0.92rem] font-medium text-[#062315] transition-transform duration-200 hover:scale-[1.03]"
                style={{ background: "var(--cm-green-bright)" }}
              >
                Richiedi una valutazione
                <ArrowRight size={17} />
              </button>
              <p className="mt-4 max-w-[440px] text-[0.88rem] leading-relaxed text-white/55">
                Lascia i dati dell'auto e un recapito: ti contattiamo per
                approfondire.
              </p>
            </div>

            <div className="lg:pt-2">
              {SELL_STEPS.map((s) => (
                <div
                  key={s.n}
                  className="group flex items-center gap-5 border-b border-white/12 py-5"
                >
                  <span className="font-mono-cm text-[0.72rem] tracking-[0.14em] text-[var(--cm-green)]">
                    {s.n}
                  </span>
                  <span className="text-[1.05rem] text-white transition-transform duration-300 group-hover:translate-x-1">
                    {s.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <LeadForm open={open} onClose={() => setOpen(false)} mode="sell" />
    </section>
  );
}
